import React from "react";
import PropTypes from "prop-types";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/fontawesome-free-solid";

const YesNoDialog = props => {
  return (
    <div className="n-dialogbox">
      <div className="n-question"> {props.question} </div>
      <div style={{ display: "block", textAlign: "center" }}>
        <div className="n-ans yes" onClick={props.handleOnClickYes}>
          <FontAwesomeIcon icon={faCheck} /> &nbsp;Yes
        </div>
        <div className="n-ans" onClick={props.handleOnClickNo}>
          <FontAwesomeIcon icon={faTimes} /> &nbsp;Cancel
        </div>
      </div>
    </div>
  );
};

export default YesNoDialog;

YesNoDialog.propTypes = {
  question: PropTypes.string.isRequired,
  handleOnClickYes: PropTypes.func.isRequired,
  handleOnClickNo: PropTypes.func.isRequired
};




// WEBPACK FOOTER //
// ./src/components/YesNoDialog.js